import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import Spacing from "../Spacing";

export default function FidelisMessageStatusDonutChart({ totalMessageStatus }) {
  const [chartData, setChartData] = useState({ series: [], options: {} });

  useEffect(() => {
    if (!totalMessageStatus) return;

    const delivered = Number(totalMessageStatus.delivered || 0);
    const queued = Number(totalMessageStatus.queued || 0);
    const failed = Number(totalMessageStatus.failed || 0);

    const series = [delivered, queued, failed];
    const labels = ["Delivered", "Queued", "Failed"];

    const options = {
      chart: { type: "donut", toolbar: { show: false } },
      labels,
      colors: ["#59a14f", "#f28e2b", "#e15759"],
      legend: {
        position: "bottom",
        fontSize: "13px",
        markers: { radius: 12 },
      },
      dataLabels: {
        enabled: true,
        formatter: (val) => `${Math.round(val)}%`,
        dropShadow: { enabled: false },
        style: { fontWeight: 600 },
      },
      stroke: { colors: ["#fff"] },
      tooltip: {
        y: {
          formatter: (val, opts) => {
            const totals = opts.globals.seriesTotals || [];
            const total = totals.reduce((a, b) => a + b, 0);
            const pct = total ? ((val / total) * 100).toFixed(1) : 0;
            return `${val} (${pct}%)`;
          },
        },
      },
      plotOptions: {
        pie: {
          donut: {
            size: "65%",
            labels: {
              show: true,
              name: { show: true, fontSize: "14px", offsetY: -7 },
              value: { show: true, fontSize: "18px", offsetY: 7, formatter: (v) => v },
              total: {
                show: true,
                label: "Total",
                fontSize: "14px",
                formatter: (w) => {
                  const totals = w.globals.seriesTotals || [];
                  return `${totals.reduce((a, b) => a + b, 0)}`;
                },
              },
            },
          },
        },
      },
      title: { show: false },
    };

    setChartData({ series, options });
  }, [totalMessageStatus]);

  return (
    <div className="docpro_chart">
      {totalMessageStatus ? (
        <ReactApexChart
          key={(chartData.series || []).join("-")}
          options={chartData.options}
          series={chartData.series}
          type="donut"
          height={320}
        />
      ) : (
        <Spacing lg="20" sm="20" />
      )}
    </div>
  );
}
